import { useEffect } from "react";
import { GetRecoilBillListData } from "../../store/billsAtom";
import CurrencyFormat from "react-currency-format";

import { Grid } from "@mui/material";
// import CurrencyFormat from "react-currency-format";
// import moment from "moment";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { useRef } from "react";
import ActionPaneComponent from "../../helpers/ActionPaneComponent";
import { twMerge } from "tailwind-merge";
import {GetExpenseListData, SetExpenseListData} from '../../store/expensesAtom';
import { useLocation, useNavigate } from "react-router-dom";
import { accountService } from "../../services/accountService";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import StatusBadge from "../../generals/StatusBadge";


function ExpenseDetailsScroll(props) {
    const getExpenseListData =  GetExpenseListData();
      const setExpenseListData =  SetExpenseListData();
  const [tableData, setTableData] = useState([]);
  const { id } = useParams();
  const [checkedAll, setCheckAll] = useState(false);
    const { pathname } = useLocation();  
    const navigate = useNavigate();
    var url = pathname.split('/')
    const currModuleId = url[1];
    const currModuleName = url[2];
    const currUserMenu = url[3];

  const mountRef = useRef(true);

  useEffect(() => {
    mountRef.current = true;
    if (mountRef.current) {
      setTableData(
        getExpenseListData.expense_info?.map((ele) => {
          return { ...ele, checked: false };
        })
      );
    }

    return () => {
      mountRef.current = false;
    };
  }, [getExpenseListData]);



    useEffect(()=> {
      // Just to to load expense data if no available
      if(!getExpenseListData?.expense_info?.length){
        getExpensesListFromApi();
      }else{
        setTableData(getExpenseListData.expense_info);
      }
     
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[getExpenseListData?.expense_info?.length, getExpenseListData?.expense_info ]);

  const onCheckboxClick = async (e, index) => {
    let element = tableData[index];
    tableData[index] = { ...element, checked: e.target.checked };
    await setTableData((prev) => {
      return [...tableData];
    });
    props?.onSelection(tableData);
  };

  const onCheckAllElement = async (selection) => {
    setCheckAll((prev) => {
      return !prev;
    });

    let newList = tableData?.map((item, i) => {
      return { ...item, checked: !selection };
    });
    await setTableData((prev) => {
      return [...newList];
    });
    props?.onSelection(newList);
  };

  const  getExpensesListFromApi =  async() => {
    accountService.getExpenseMainList().then( response => {
      const serverData =  response?.data;
      if(serverData?.expense_info?.length){
          setTableData(serverData?.expense_info);
      }
  
      const buildData = {
          vendor_info:serverData?.vendor_info?.length ? serverData?.vendor_info: [],
          expense_account:serverData?.expense_account?.length ? serverData?.expense_account: [],
          expense_info:serverData?.expense_info?.length ? serverData?.expense_info: [],
          expense_status:serverData?.expense_status?.length ? serverData?.expense_status: [],
          paid_account:serverData?.paid_account?.length ? serverData?.paid_account: [],
          tax_info:serverData?.tax_info?.length ? serverData?.tax_info: [],
  
  
      }
      
      setExpenseListData(buildData);
   
      });
    }
  


  const viewDetails = (id)=> {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`)
  }

  return (
    <section className="border-[1px] rounded-lg bg-white border-gray-200 flex flex-col overflow-y-scroll h-[300px] lg:h-[1000px] scrollbar-thumb-gray-500 scrollbar-thin scrollbar-track-gray-100 pb-[100px]">
      <div className="border-b-[1px] border-b-gray-300">
        {/* <ActionPaneComponent
          bulkActionData={billListData["Filtering_Criteria"]}
          onSelectBulkAction={onActionFilterPerform}
        /> */}
      </div>
      <div
        className={twMerge(
          `p-2 lg:p-1 grid grid-cols-2 lg:grid-cols-none  border-b-[1px] cursor-pointer border-gray-200`
        )}
      >
        <label className="ml-1 flex flex-row items-center">
          <input
            onChange={(e) => onCheckAllElement(checkedAll)}
            type="checkbox"
            className="w-4 h-4 border-[1px] border-gray-300 rounded-sm cursor-pointer"
            checked={checkedAll ? checkedAll : ""}
          />
          <span className="ml-2 font-bold ">Select all</span>
        </label>
      </div>
      <div>
        {tableData?.map((exp, index) => {
          return (
            <div
              key={index}
              className={twMerge(
                `p-2 lg:p-1 grid grid-cols-2 lg:grid-cols-none  border-b-[1px] cursor-pointer border-gray-200 ${
                  Number(id) === exp?.Ref_No
                    ? "bg-gray-200"
                    : "hover:bg-gray-100"
                }`
              )}
            >
              <div className="flex flex-row">
                <div className="ml-1">
                  <input
                    onChange={(e) => onCheckboxClick(e, index)}
                    checked={exp?.checked ? exp?.checked : ""}
                    type="checkbox"
                    className="w-4 h-4 border-[1px] border-gray-300 rounded-sm cursor-pointer"
                  />
                </div>
                <div onClick={() => viewDetails(exp?.Ref_No)}>
                  <label className="ml-2 ">
                    <span className="text-sm font-bold text-gray-700">
                      {exp?.Expense_Account_Name}{" "}
                    </span>{" "}
                    <br></br>
                    <span className="text-xs text-gray-400 font-semibold italic">
                      {formatCustomNumber(exp?.Amount || 0)}
                    </span>
                    <br></br>
                    <span className="text-sm lg:text-xs font-medium text-gray-600">
                      {/* <CurrencyFormat
                        value={parseFloat(exp.Bill_Amount)?.toFixed(2)}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"₦"}
                      /> */}
                    </span>
                  </label>
                </div>
              </div>
              <div className="lg:mt-2 lg:ml-5 ">
                <div className={twMerge("text-sm font-normal")}>
                  <StatusBadge
                    statusId={exp?.Status_Id}
                    statusName={exp?.Status_Name}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default ExpenseDetailsScroll;
